import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IApplicationState, IConnectedReduxProps } from '../../Store';
import { I18N } from '../../Store/I18n/Types';
import { IUserState } from '../../Store/User/Types';
import { IUserManagementState } from '../../Store/UserManagement/Types';
import { UserManagementContentGroupsList } from './UserManagementTabsContent/GroupsTab';
import { UserManagementContentRightsList } from './UserManagementTabsContent/RightsTab';
import { UserManagementContentUsersList } from './UserManagementTabsContent/UsersTab';

export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	i18n: I18N;
	router: RouteComponentProps<IRouterMatchParams>;
	user: IUserState;
	userManagement: IUserManagementState;
}

interface IPropsFromDispatch {}

type AllProps = IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

export class UserManagementContentComponent extends React.Component<AllProps> {
	public constructor(props: AllProps) {
		super(props);
	}

	public render(): React.ReactNode {
		let mode = 0;
		switch (this.props.router.match.params.type) {
			case 'users':
				mode = 0;
				break;
			case 'groups':
				mode = 1;
				break;
			case 'rights':
				mode = 2;
				break;
			default:
				mode = 0;
		}
		return (
			<React.Fragment>
				<MD.Tabs
					key={'tabs_users_groups_rights'}
					onChange={this.handleTabs.bind(this)}
					value={mode}
					indicatorColor="primary"
					textColor="primary"
				>
					<MD.Tab label={this.props.i18n._('Users')} key={'users'} />
					{this.props.user.groupID === 2 ? (
						<MD.Tab
							label={this.props.i18n._('Groups')}
							key={'groups'}
						/>
					) : (
						''
					)}
					{mode === 2 ? (
						<MD.Tab
							label={this.props.i18n._('Rights')}
							key={'rights'}
						/>
					) : (
						''
					)}
				</MD.Tabs>
				<this.TabPanel
					value={mode}
					index={0}
					key={'userManagementContentUsersList'}
				>
					<Route component={UserManagementContentUsersList} key={'userManagementContentUsersList_route'}/>
				</this.TabPanel>
				<this.TabPanel
					value={mode}
					index={1}
					key={'userManagementContentGroupsList'}
				>
					<Route component={UserManagementContentGroupsList}
						key={'userManagementContentGroupsList_route'} />
				</this.TabPanel>
				<this.TabPanel
					value={mode}
					index={2}
					key={'userManagementContentRightsList'}
				>
					<Route component={UserManagementContentRightsList}
						key={'userManagementContentRightsList_route'} />
				</this.TabPanel>
			</React.Fragment>
		);
	}

	private TabPanel(props: any): JSX.Element {
		const { children, value, index } = props;
		return (
			<div key={'div1_' + index}>
				{value === index && <div key={'div2_' + index}>{children}</div>}
			</div>
		);
	}

	private handleTabs(e: React.ChangeEvent<{}>, val: number) {
		switch (val.toString(10)) {
			case '0':
				this.props.router.history.push(`/users/users`);
				break;
			case '1':
				this.props.router.history.push('/users/groups');
				break;
			case '2':
				this.props.router.history.push(
					`/users/rights/${this.props.router.match.params.groupName}`
				);
				break;
			default:
				this.props.router.history.push(`/users/users`);
		}
	}
}

const mapStateToProps = (
	{ i18n, user, userManagement }: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	i18n: i18n.i18n,
	router: ownProps,
	user,
	userManagement,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export const UserManagementContent = connect(
	mapStateToProps,
	mapDispatchToProps
)(UserManagementContentComponent);
